export default "__VITE_ASSET__4c39498c__"